import React from 'react'
import { useAppTranslation } from '../../hooks'
import { CustomAutocomplete } from './CustomAutoComplete'

export type ProviderSelectProps = {
  value?: string
  onChange?: (value: string | null) => void
  getDefaultValue?: (value?: string | null) => void
  disableClearable?: boolean
  disabled?: boolean
}

export const ProviderSelect: React.FC<ProviderSelectProps> = ({ 
  value, 
  onChange, 
  getDefaultValue, 
  disableClearable = false,
  disabled = false 
}) => {
  const { label } = useAppTranslation()

  // Create provider options array
  const providerOptions = React.useMemo(() => [
    { value: 'GlobalToteTicketService', label: 'Global' },
    { value: 'TotelinkTicketService', label: 'United' }
  ], [])

  // Find current selected option based on external value
  const selectedOption = React.useMemo(() => {
    if (!value) return null
    return providerOptions.find(option => option.value === value) || null
  }, [value, providerOptions])

  return (
    <CustomAutocomplete
      data={providerOptions}
      defaultValue={selectedOption}
      onChangeValue={(selectedOption, action) => {
        if (onChange) {
          // Pass the selected value or null when clearing
          onChange(selectedOption?.value || null)
        }
      }}
      placeholder={label('PROVEEDOR')}
      keyLabel="label"
      label={label('PROVEEDOR')}
      disableClearable={disableClearable}
      disabled={disabled}
    />
  )
}
